<div id="main-wrapper">
    <div id="content">
        <div class="container-fluid invoice-container">
            <div class="row align-items-center">
                <div class="col-sm-4 text-center text-sm-left">
                    <p><img src="{{imageURL}}" alt="" width="170" height="60" title="" /></p>
                </div>
                <div class="col-sm-5 text-center text-sm-left d-none d-sm-block">
                </div>
                <div class="col-sm-3 text-center text-sm-left">
                    <!-- <span class="d-lg-block btn btn-light border text-black-50 shadow-none" (click)="backClicked()"><a
              href="javascript:void(0)"><i class="fas fa-arrow-left"></i>Back </a>
          </span> -->
                </div>
                <div *ngIf="bookingList.Status=='Confirmed'" class="col-12 mb-2 text-center">
                    <div class="btn-group btn-group-sm float-right d-print-none">
                        <a href="javascript:window.print()" class="btn btn-light border text-black-50 shadow-none"><i
                class="fa fa-print"></i> Print</a>
                        <a (click)="showTicket(bookingList.ReservationID)" class="btn btn-light border text-black-50 shadow-none"><i
                class=""></i> Print Voucher</a>
                        <!-- <a (click)="showInvoice(bookingList.ReservationID)"
              class="btn btn-light border text-black-50 shadow-none"><i class=""></i> Agent Invoice</a> -->
                        <!-- <a (click)="showcustInvoice(bookingList.ReservationID)"
              class="btn btn-light border text-black-50 shadow-none"><i class=""></i>Customer Invoice</a> -->
                    </div>
                </div>
                <div class="col-sm-4 text-center text-sm-left">
                </div>
                <!-- <div *ngIf="bookingList.Status=='Pending'" class="col-12 text-center"> -->
                <div class="col-12 text-center" *ngIf="bookingList.Status!='Refunded'">
                    <div class="btn-group btn-group-sm float-right d-print-none">
                        <a href="#" class="btn btn-light border text-black-50 shadow-none" data-toggle="modal" data-target="#PNRUpdate" title="PNR Update" *ngIf="logintype=='OO' || logintype=='OOU'"><i class=""></i>
              PNR Update</a>
                        <!-- <a href="#" class="btn btn-light border text-black-50 shadow-none" data-toggle="modal"
              data-target="#CancelTicket" title="Cancel Ticket" *ngIf="logintype=='OO' || logintype=='OOU'"><i
                class=""></i> Cancel Booking</a> -->
                        <a href="#" class="btn btn-light border text-black-50 shadow-none" data-toggle="modal" data-target="#sendemail" title="Send Email" *ngIf="bookingList.Status=='Confirmed'"><i class=""></i> Email Voucher</a>
                        <!-- <a href="#" class="btn btn-light border text-black-50 shadow-none" data-toggle="modal"
              data-target="#sendsms" title="Send SMS"><i class=""></i> Send SMS</a> -->
                        <a href="#" class="btn btn-light border text-black-50 shadow-none" data-toggle="modal" data-target="#CancelTicket" title="Cancel Ticket" *ngIf="logintype=='OO' || logintype=='OOU'"><i
                class=""></i> Reject Booking</a>
                    </div>
                </div>
                <div class="col-12 text-center mt-2" *ngIf="bookingList.Status=='Pending'">
                    <div class="btn-group btn-group-sm float-right d-print-none">
                        <a href="#" class="btn btn-light border text-black-50 shadow-none" data-toggle="modal" data-target="#Logs" title="Check Booking Log" *ngIf="logintype=='OO' || logintype=='OOU'" (click)='getBookingLogs()'><i class=""></i> Logs</a>

                    </div>
                </div>
                <!-- <div *ngIf="bookingList.Status=='Confirmed'" class="col-12 text-center">
          <div class="btn-group btn-group-sm float-right d-print-none">
            <a href="#" class="btn btn-light border text-black-50 shadow-none" data-toggle="modal"
              data-target="#sendemail" title="Send Email"><i class=""></i> Email e-Ticket</a>
            <a href="#" class="btn btn-light border text-black-50 shadow-none" data-toggle="modal"
              data-target="#sendsms" title="Send SMS"><i class=""></i> Send SMS</a>
            <a href="#" class="btn btn-light border text-black-50 shadow-none" data-toggle="modal"
              data-target="#CancelTicket" title="Cancel Ticket"><i class=""></i> Cancel Ticket</a>
          </div>
        </div> -->
                <div class="col-12 text-center">
                    <div *ngIf="bookingList.Status=='On Hold'">
                        <div class="btn-group btn-group-sm float-right d-print-none ml-1">
                            <a href="#" class="btn btn-light border text-black-50 shadow-none" data-toggle="modal" data-target="#confirm" title="confirm"><i class=""></i><b> confirm On Hold PNR</b></a>
                        </div>
                    </div>
                    <div *ngIf="bookingList.Status=='On Hold'">
                        <div class="btn-group btn-group-sm float-right d-print-none ml-1">
                            <a href="#" class="btn btn-light border text-black-50 shadow-none" data-toggle="modal" data-target="#Extended" title="confirm"><i class=""></i><b> Extended Hold PNR</b></a>
                        </div>
                    </div>
                    <div>
                        <!-- <div class="btn-group btn-group-sm float-right d-print-none ml-1">
              <a href="#" class="btn btn-light border text-black-50 shadow-none" data-toggle="modal"
                data-target="#Release" title="confirm"><i class=""></i><b>Release</b></a>
            </div> -->
                    </div>
                </div>
            </div>
            <hr class="mb-4 pb-2">
            <p class="mt-3 line-height-4 text-3">Confirmation Number: {{bookingList.ReservationID}}<br>
            </p>
            <div class="card mb-3">
                <div class="card-header">
                    <div class="">
                        <div class="row">
                            <div class="col-6 col-sm-8  time-info   mt-sm-0">
                                <h6 class="m-0 trip-place"><i class="fas fa-map-marker-alt mr-2"></i>{{bookingList.LeaveFrom}}
                                </h6>
                            </div>
                            <div class="col-6 col-sm-4 text-right time-info  mt-sm-0">
                                <h6 class="m-0 trip-place">{{bookingList.Nights}}
                                </h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="CancelTicket" class="modal fade" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h6 class="modal-title">Cancel/Reject Booking</h6>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span
                  aria-hidden="true">&times;</span> </button>
                        </div>
                        <div class="modal-body">
                            <div class="flight-details">
                                <div class="tab-content " id="myTabContent">
                                    <div class="tab-content">
                                        <div class="tab-pane fade show active" id="CancelTicket" role="tabpanel" aria-labelledby="CancelTicket-tab">
                                            <form id="CancelTicket" method="post" autocomplete="off">

                                                <div class="row flex-row  px-md-6">
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">
                                                        <span class="text-2 text-dark">Confirmation ID &nbsp; :&nbsp;&nbsp;&nbsp;
                              <b>{{bookingList.ReservationID}}</b></span>
                                                    </div>
                                                    <div class="col-12 col-sm-6 text-left time-info mt-3 mt-sm-0"> <span class="text-2 text-dark">PNR &nbsp;:&nbsp;&nbsp;&nbsp;
                              <b>{{bookingList.PNR}}</b></span>
                                                    </div>
                                                </div>
                                                <div class="row flex-row  px-md-6 mt-2">
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">
                                                        <span class="text-2 text-dark">ShipName &nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                              {{bookingList.ShipName}}</span>
                                                    </div>
                                                    <div class="col-12 col-sm-6 text-left time-info mt-3 mt-sm-0"> <span class="text-2 text-dark">Sailing&nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                              {{bookingList.Sailing}}</span>
                                                    </div>
                                                </div>
                                                <div class="row flex-row  px-md-6 mt-2">
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">
                                                        <span class="text-2 text-dark">CruiseLine &nbsp;&nbsp;&nbsp; :
                              &nbsp;&nbsp;&nbsp;{{bookingList.CruiseLine}}</span>
                                                    </div>
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info"> <span class="text-2 text-dark">TravelDate &nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                              {{bookingList.DOJ}}</span>
                                                    </div>
                                                </div>
                                                <div class="row flex-row  px-md-6 mt-2">
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">
                                                        <span class="text-2 text-dark">DepartTime &nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                              {{bookingList.DepartTime}}</span>
                                                    </div>
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">
                                                        <span class="text-2 text-dark">Duration &nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                              {{bookingList.Nights}}</span>
                                                    </div>
                                                </div>
                                                <div class="row flex-row  px-md-6 mt-2">
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">
                                                        <span class="text-2 text-dark">Pax Count &nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                              {{bookingList.PaxCount}}</span>
                                                    </div>
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">
                                                        <span class="text-2 text-dark">Supplier &nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                              {{bookingList.Supplier}}</span>
                                                    </div>
                                                </div>
                                                <div class="row flex-row  px-md-6 mt-2">
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">
                                                        <span class="text-2 text-dark">LeaveFrom &nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                              {{bookingList.LeaveFrom}}</span>
                                                    </div>
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">
                                                        <span class="text-2 text-dark">Description &nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                              {{bookingList.Description}}</span>
                                                    </div>
                                                </div>
                                                <div class="row flex-row  px-md-6 mt-2 mb-4">
                                                    <div class="col-12 col-sm-12 text-left time-info mt-3 mt-sm-0">
                                                        <!-- <div class="form-group"> -->
                                                        <div class="text-3 text-dark mb-2">Remarks &nbsp;&nbsp;&nbsp;:&nbsp;</div>
                                                        <textarea [(ngModel)]="remarks" class="form-control" list="Massage" name="Massage" required placeholder="Remarks, if any" type="text">
                                  </textarea>
                                                        <!-- </div> -->
                                                    </div>
                                                </div>
                                                <button class=" btn btn-primary btn-block mt-2" (click)="CancelTicket()" type="submit">Cancel/Reject Booking</button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="PNRUpdate" class="modal fade" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h6 class="modal-title">PNR Update</h6>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span
                  aria-hidden="true">&times;</span> </button>
                        </div>
                        <div class="modal-body">
                            <div class="flight-details">
                                <div class="tab-content " id="myTabContent">
                                    <div class="tab-content">
                                        <div class="tab-pane fade show active" id="PNRUpdate" role="tabpanel" aria-labelledby="PNRUpdate-tab">
                                            <form id="PNRUpdate" method="post" autocomplete="off">

                                                <div class="row flex-row  px-md-6">
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">
                                                        <span class="text-2 text-dark">Confirmation ID &nbsp; :&nbsp;&nbsp;&nbsp;
                              <b>{{bookingList.ReservationID}}</b></span>
                                                    </div>
                                                    <div class="col-12 col-sm-6 text-left time-info mt-3 mt-sm-0"> <span class="text-2 text-dark">PNR &nbsp;:&nbsp;&nbsp;&nbsp;
                              <b>{{bookingList.PNR}}</b></span>
                                                    </div>
                                                </div>
                                                <div class="row flex-row  px-md-6 mt-2">
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">
                                                        <span class="text-2 text-dark">ShipName &nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                              {{bookingList.ShipName}}</span>
                                                    </div>
                                                    <div class="col-12 col-sm-6 text-left time-info mt-3 mt-sm-0"> <span class="text-2 text-dark">Sailing&nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                              {{bookingList.Sailing}}</span>
                                                    </div>
                                                </div>
                                                <div class="row flex-row  px-md-6 mt-2">
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">
                                                        <span class="text-2 text-dark">CruiseLine &nbsp;&nbsp;&nbsp; :
                              &nbsp;&nbsp;&nbsp;{{bookingList.CruiseLine}}</span>
                                                    </div>
                                                    <div class="col-12 col-sm-6 text-left time-info mt-3 mt-sm-0"> <span class="text-2 text-dark">TravelDate &nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                              {{bookingList.TravelDate}}</span>
                                                    </div>
                                                </div>
                                                <div class="row flex-row  px-md-6 mt-2">
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">
                                                        <span class="text-2 text-dark">DepartTime &nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                              {{bookingList.DepartTime}}</span>
                                                    </div>
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">
                                                        <span class="text-2 text-dark">Duration &nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                              {{bookingList.Nights}}</span>
                                                    </div>
                                                </div>
                                                <div class="row flex-row  px-md-6 mt-2">
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">
                                                        <span class="text-2 text-dark">Pax Count &nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                              {{bookingList.PaxCount}}</span>
                                                    </div>
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">
                                                        <span class="text-2 text-dark">Supplier &nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                              {{bookingList.Supplier}}</span>
                                                    </div>
                                                </div>
                                                <div class="row flex-row  px-md-6 mt-2">
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">
                                                        <span class="text-2 text-dark">LeaveFrom &nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                              {{bookingList.LeaveFrom}}</span>
                                                    </div>
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">
                                                        <span class="text-2 text-dark">Description &nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                              {{bookingList.Description}}</span>
                                                    </div>
                                                </div>
                                                <div class="row flex-row  px-md-6 mt-2">
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">PNR &nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                                                        <input class="" name="CRSPNR" [(ngModel)]="PNR" id="CRSPNR" ng-required="true" type="text">
                                                    </div>
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">Deck &nbsp;&nbsp;&nbsp; :&nbsp;&nbsp;&nbsp;
                                                        <input class="" name="Deck " [(ngModel)]="Deck" id="Deck " ng-required="true" type="text">
                                                    </div>
                                                </div>
                                                <div class="row flex-row  px-md-6 mt-2">
                                                    <div class="col-12 col-sm-6 text-left d-lg-flex company-info">Cabin &nbsp; :&nbsp;&nbsp;&nbsp;
                                                        <input class="" name="Cabin " [(ngModel)]="Cabin" id="Cabin " ng-required="true" type="text">
                                                    </div>
                                                </div>

                                                <button class=" btn btn-primary btn-block mt-2" (click)="UPDATEPNR()" type="submit">Update Cabin/Deck
                          </button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sendsms" class="modal fade" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content p-sm-3">
                        <div class="modal-body">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span
                  aria-hidden="true">&times;</span> </button>
                            <ul class="nav nav-tabs" role="tablist">
                                <li class="nav-item"> <a id="SMS-tab" class="nav-link active text-abc" data-toggle="tab" href="#SMS" role="tab" aria-controls="login" aria-selected="true">Do u want to give another Mobile No ?</a>
                                </li>
                            </ul>
                            <div class="tab-content pt-4">
                                <div class="tab-pane fade show active" id="SMS" role="tabpanel" aria-labelledby="SMS-tab">
                                    <form id="SMSForm" method="post" autocomplete="off">
                                        <div class="form-group">
                                            <input type="tel" minlength="10" maxlength="10" (keypress)="keyPress($event)" name="username" [(ngModel)]="mobileSEND" class="form-control" id="agentloginMobile" required placeholder="Enter your Mobile No ">
                                        </div>
                                        <!-- <button class="btn btn-primary btn-block" (click)="emaileTicket('SMS')" type="submit">Send
                      SMS</button> -->
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="Logs" class="modal fade" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h6 class="modal-title"> Booking Logs as received from Supplier</h6>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span
                            aria-hidden="true">&times;</span> </button>
                        </div>
                        <div class="modal-body">
                            <div class="flight-details">
                                <div class="tab-content " id="myTabContent">
                                    <div class="tab-content">
                                        <div class="tab-pane fade show active" id="logBooking" role="tabpanel" aria-labelledby="Logs-tab">
                                            <form id="BookingLog" method="post" autocomplete="off">
                                                <div class="px-md-12">
                                                    <!-- <table class="table table-hover border"> -->
                                                    <h6 class="thead-light">Log</h6>
                                                    <!-- <tbody> -->
                                                    <div *ngFor="let booking of bookingLogs;let i = index">
                                                        <div class="col-sm-12 card col-6 mt-1 mb-1">{{booking.response}}</div>
                                                    </div>
                                                    <!-- </tbody> -->
                                                    <!-- </table> -->
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sendemail" class="modal fade" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content p-sm-3">
                        <div class="modal-body">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span
                  aria-hidden="true">&times;</span> </button>
                            <ul class="nav nav-tabs" role="tablist">
                                <li class="nav-item"> <a id="email-tab" class="nav-link active text-abc" data-toggle="tab" href="#email" role="tab" aria-controls="login" aria-selected="true">Do u want to give another Email-Id?</a> </li>
                            </ul>
                            <div class="tab-content pt-4">
                                <div class="tab-pane fade show active" id="email" role="tabpanel" aria-labelledby="email-tab">
                                    <form id="emailForm" method="post" autocomplete="off">
                                        <div class="form-group">
                                            <input type="email" name="username" [(ngModel)]="EmailSEND" class="form-control" id="agentloginMobile" required placeholder="Enter your Email-ID ">
                                        </div>
                                        <button class=" btn btn-primary btn-block" (click)="emaileTicket()" type="submit">Email Voucher</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12  mt-3 mt-md-0 ">
                <div class="card-body">
                    <div class="row align-items-center trip-title">
                        <div class="col-sm-12 ">
                            <div class="mb-2 row">
                                <div class="col-sm-2 col-6">
                                    <span class="text-2 text-danger d-block">ShipName :
                  </span>
                                </div>
                                <div class="col-sm-4 col-6">
                                    <span class=" text-2">{{bookingList.ShipName}}
                  </span>
                                </div>
                                <div class="col-sm-2 col-6">
                                    <span class="text-2 text-danger d-block">Sailing :
                  </span>
                                </div>
                                <div class="col-sm-4 col-6">
                                    <span class=" text-2">{{bookingList.Sailing}}
                  </span>
                                </div>
                                <div class="col-sm-2 col-6">
                                    <span class="text-2 text-danger d-block">Continent :
                  </span>
                                </div>
                                <div class="col-sm-4 col-6">
                                    <span class=" text-2">{{bookingList.Continent}}
                  </span>
                                </div>
                                <div class="col-sm-2 col-6">
                                    <span class="text-2 text-danger d-block">CruiseLine :
                  </span>
                                </div>
                                <div class="col-sm-4 col-6">
                                    <span class=" text-2">{{bookingList.CruiseLine}}
                  </span>
                                </div>
                                <div class="col-sm-2 col-6">
                                    <span class="text-2 text-danger d-block">Destination :
                  </span>
                                </div>
                                <div class="col-sm-4 col-6">
                                    <span class=" text-2">{{bookingList.Destination}}
                  </span>
                                </div>
                                <div class="col-sm-2 col-6">
                                    <span class="text-2 text-danger d-block">Embarkation :
                  </span>
                                </div>
                                <div class="col-sm-4 col-6">
                                    <span class=" text-2">{{bookingList.Embarkation}}
                  </span>
                                </div>
                                <div class="col-sm-2 col-6">
                                    <span class="text-2 text-danger d-block">Description :
                  </span>
                                </div>
                                <div class="col-sm-4 col-6">
                                    <span class=" text-2">{{bookingList.Description}}
                  </span>
                                </div>
                                <div class="col-sm-2 col-6">
                                    <span class="text-2 text-danger d-block">LeaveFrom :
                  </span>
                                </div>
                                <div class="col-sm-4 col-6">
                                    <span class=" text-2">{{bookingList.LeaveFrom}}
                  </span>
                                </div>
                                <div class="col-sm-2 col-6">
                                    <span class="text-2 text-danger d-block">TravelDate :
                  </span>
                                </div>
                                <div class="col-sm-4 col-6">
                                    <span class=" text-2">{{bookingList.TravelDate}}
                  </span>
                                </div>
                                <div class="col-sm-2 col-6">
                                    <span class="text-2 text-danger d-block">DepartTime :
                  </span>
                                </div>
                                <div class="col-sm-4 col-6">
                                    <span class=" text-2">{{bookingList.DepartTime}}
                  </span>
                                </div>
                                <div class="col-sm-2 col-6">
                                    <span class="text-2 text-danger d-block">Supplier :
                  </span>
                                </div>
                                <div class="col-sm-4 col-6">
                                    <span class=" text-2">{{bookingList.Supplier}}
                  </span>
                                </div>
                                <div class="col-sm-2 col-6">
                                    <span class="text-2 text-danger d-block">Duration :
                  </span>
                                </div>
                                <div class="col-sm-4 col-6">
                                    <span class=" text-2">{{bookingList.Nights}}
                  </span>
                                </div>
                                <div class="col-sm-2 col-6">
                                    <span class="text-2 text-danger d-block">PNR :
                  </span>
                                </div>
                                <div class="col-sm-4 col-6">
                                    <span class=" text-2">{{bookingList.PNR}}
                  </span>
                                </div>
                                <div class="col-sm-2 col-6">
                                    <span class="text-2 text-danger d-block">Pax Count :
                  </span>
                                </div>
                                <div class="col-sm-4 col-6">
                                    <span class=" text-2">{{bookingList.PaxCount}}
                  </span>
                                </div>
                                <div class="col-sm-2 col-6">
                                    <span class="text-2 text-danger d-block">Deck :
                  </span>
                                </div>
                                <div class="col-sm-4 col-6">
                                    <span class=" text-2">{{bookingList.Deck}}
                  </span>
                                </div>
                                <div class="col-sm-2 col-6">
                                    <span class="text-2 text-danger d-block">Cabin :
                  </span>
                                </div>
                                <div class="col-sm-4 col-6">
                                    <span class=" text-2">{{bookingList.Cabin}}
                  </span>
                                </div>
                                <!-- <div class="col-sm-2 col-6">
                  <span class="text-2 text-danger d-block">HoldUpto :
                  </span>
                </div>
                <div class="col-sm-4 col-6">
                  <span class=" text-2">{{bookingList.HoldUpto}}
                  </span>
                </div> -->
                                <!-- <div class="col-sm-2 col-6">
                  <span class="text-2 text-danger d-block">Pax Name :
                  </span>
                </div> -->
                                <!-- <div class="col-sm-4 col-6" *ngFor="let Pax of bookingList.PaxArray">
                  <span class=" text-2">{{Pax.name}}
                  </span>
                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="mt-4">
                        <tr>
                            <td>
                                <table width="900" border="0" cellspacing="0" cellpadding="0" style="border:1px solid #d9dbdd">
                                    <tr style="line-height:-1px">
                                        <td style="background:#f4f6f8; font-size:15px; font-weight:500; color:#000; padding:10px;font-family: 'Roboto', sans-serif;">
                                            Cruise Itinerary</td>
                                        <td style="background:#f4f6f8; font-size:15px; font-weight:500; color:#000; padding:10px;font-family: 'Roboto', sans-serif;"></td>
                                        <td style="background:#f4f6f8; font-size:15px; font-weight:500; color:#000; padding:10px;font-family: 'Roboto', sans-serif;"></td>
                                        <td style="background:#f4f6f8; font-size:15px; font-weight:500; color:#000; padding:10px;font-family: 'Roboto', sans-serif;"></td>
                                    </tr>
                                    <tr style="line-height:-1px">
                                        <td style="font-size:14px; font-weight:500; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0 8px 10px; border-bottom:1px solid #d9dbdd;border-top:1px solid #d9dbdd; width: 20% ">
                                            Date</td>
                                        <td style="font-size:14px; font-weight:500; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0; border-bottom:1px solid #d9dbdd;border-top:1px solid #d9dbdd; width: 20% ">
                                            Day</td>
                                        <td style="font-size:14px; font-weight:500; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0; border-bottom:1px solid #d9dbdd;border-top:1px solid #d9dbdd; width: 20% ">
                                            Depart</td>
                                        <td style="font-size:14px; font-weight:500; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0; border-bottom:1px solid #d9dbdd;border-top:1px solid #d9dbdd; width: 20% ">
                                            Port / Itinerary</td>
                                    </tr>
                                    <tr style="line-height:-1px" *ngFor="let itinerary of Cruisedata.itinerary">
                                        <td style="font-size:13px; font-weight:400; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0 8px 10px; border-bottom:1px solid #d9dbdd ">
                                            {{itinerary.SailingDate}}</td>
                                        <td style="font-size:13px; font-weight:400; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0; border-bottom:1px solid #d9dbdd ">
                                            {{itinerary.Sailday}}</td>
                                        <td style="font-size:13px; font-weight:400; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0; border-bottom:1px solid #d9dbdd ">
                                            {{itinerary.Timings}}</td>
                                        <td style="font-size:13px; font-weight:400; color:#000;font-family: 'Roboto', sans-serif; padding:8px 0; border-bottom:1px solid #d9dbdd ">
                                            {{itinerary.BriefDesc}}</td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </div>
                    <div class="mt-4">
                        <tr class="">
                            <td>
                                <table width="900" border="0" cellspacing="0" cellpadding="0" style="border:1px solid #d9dbdd">
                                    <tr style="line-height:-1px">
                                        <td style="background:#f4f6f8; font-size:15px; font-weight:500; color:#000; padding:10px;font-family: 'Roboto', sans-serif;">
                                            Fare Summary</td>
                                    </tr>
                                    <tr style="line-height:-1px">
                                        <td>
                                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                                <tr style="line-height:-1px">
                                                    <td style="font-size:13px; font-weight:500; color:#000; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif;">
                                                        Traveller Name</td>
                                                    <td style="font-size:13px; font-weight:500; color:#000; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif; text-align:right">
                                                        Base Fare</td>
                                                    <td style="font-size:13px; font-weight:500; color:#000; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif; text-align:right">
                                                        Taxes and Charges</td>
                                                    <td style="font-size:13px; font-weight:500; color:#000; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif; text-align:right">
                                                        Total</td>
                                                </tr>
                                                <tr style="line-height:-1px" *ngFor="let basePrice of bookingList.paxDetails; let i = index">
                                                    <td style="font-size:13px; font-weight:400; color:#525252; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif;">
                                                        {{basePrice.Title}}&nbsp;{{basePrice.FirstName}}&nbsp;{{basePrice.LastName}}&nbsp;({{basePrice.PaxType}}&nbsp;{{i+1}})</td>
                                                    <td style="font-size:13px; font-weight:400; color:#525252; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif; text-align:right">
                                                        ₹ {{basePrice.baseAmt |number}}</td>
                                                    <td style="font-size:13px; font-weight:400; color:#525252; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif; text-align:right">
                                                        ₹ {{basePrice.portCharges |number}}</td>
                                                    <td style="font-size:13px; font-weight:400; color:#525252; padding:10px 8px;border-bottom:1px solid #d9dbdd;font-family: 'Roboto', sans-serif; text-align:right">
                                                        ₹ {{(basePrice.baseAmt-0)+(basePrice.portCharges-0)|number}}</td>
                                                </tr>
                                            </table>

                                        </td>
                                    </tr>
                                    <tr style="line-height:-1px">
                                        <td align="right" style="font-size:15px; font-weight:400; color:#525252; padding:10px 8px 3px 8px;font-family: 'Roboto', sans-serif;">
                                            GST: <span style="color:#000; font-weight:500">₹{{bookingList.GST |number}}</span></td>
                                    </tr>
                                    <tr style="line-height:-1px">
                                        <td align="right" style="font-size:15px; font-weight:400; color:#525252; padding:3px 8px;font-family: 'Roboto', sans-serif;">
                                            TCS: <span style="color:#000; font-weight:500">₹{{bookingList.TCS |number}}</span></td>
                                    </tr>
                                    <tr style="line-height:-1px">
                                        <td align="right" style="font-size:15px; font-weight:400; color:#525252; padding:3px 8px;font-family: 'Roboto', sans-serif;">
                                            Discount/Comm: <span style="color:#000; font-weight:500">₹{{bookingList.Comm |number}}</span></td>
                                    </tr>
                                    <tr style="line-height:-1px">
                                        <td align="right" style="font-size:15px; font-weight:400; color:#525252; padding:3px 8px 10px 8px;font-family: 'Roboto', sans-serif;">
                                            Promo code discount: <span style="color:#000; font-weight:500">₹{{bookingList.PromoDiscount |number}}</span>
                                        </td>
                                    </tr>
                                    <tr style="line-height:-1px">
                                        <td align="right" style="font-size:22px; font-weight:600; color:#000;border-top:1px solid #d9dbdd; padding:8px 8px;font-family: 'Roboto', sans-serif;">
                                            Total Net Fare : <span style="color:#000; font-size:25px; font-weight:600">₹
                      {{bookingList.TxnAmt |number}}</span></td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>